/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 *
 */
export default {
  /* --------查询时操作符号------ */
  EQ: 1, // 等于
  LT: 2, // 小于
  LE: 3, // 小于等于
  GT: 4, // 大于
  GE: 5, // 大于等于
  NE: 6, // 不等于
  LI: 7, // 相似
  IN: 8, // 在···范围内
  NL: 9, // 不相似
  NI: 10 // 不在...范围
}
